var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-side-drawer display-flex",class:[
		_vm.sidebarClass,
		{
			'sidebar-open': _vm.sideBarState !== 'closed' && !_vm.forceFullWidth,
			'width-100': _vm.forceFullWidth,
			'full-width': _vm.isWideWidget && !_vm.forceFullWidth,
			'widget-pdf-viewer-max-width': _vm.isFileViewerActive && !_vm.forceFullWidth,
			'narrow-widget-max-width': _vm.isWidget && !_vm.isWideWidget && !_vm.isFileViewerActive && !_vm.forceFullWidth,
		},
	]},[_c('v-fade-transition',[_c('div',{staticClass:"height-100 width-100"},[_vm._t("default"),_c('ShrinkButton',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeSideBar')}}})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }